import { useEffect, useRef, useState } from 'react';

const DESKTOP_WIDTH = 1280;

interface ScaledArtifactFrameProps {
    html: string;
    title: string;
    sandbox: string;
}

export function ScaledArtifactFrame({
    html,
    title,
    sandbox
}: ScaledArtifactFrameProps) {
    const containerRef = useRef<HTMLDivElement>(null);
    const [box, setBox] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const element = containerRef.current;
        if (!element) return;
        const observer = new ResizeObserver(([entry]) =>
            setBox({
                width: entry.contentRect.width,
                height: entry.contentRect.height
            })
        );
        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    const scale = box.width > 0 ? Math.min(1, box.width / DESKTOP_WIDTH) : 1;

    return (
        <div ref={containerRef} className="w-full h-full overflow-hidden">
            <iframe
                srcDoc={html}
                sandbox={sandbox}
                title={title}
                style={{
                    display: 'block',
                    width: box.width / scale,
                    height: box.height / scale,
                    transform: `scale(${scale})`,
                    transformOrigin: 'top left',
                    border: 'none',
                    background: '#fff'
                }}
            />
        </div>
    );
}
